module.exports = hljs;